// removed by extract-text-webpack-plugin
module.exports = {"container":"_1pgODM_Ays8ZvYRIwLrX9x","delete":"_2W2qFIuWkqU1QiglMKV2"};


//////////////////
// WEBPACK FOOTER
// ./src/App/components/fields/RequiredFiles/styles.css
// module id = 2971
// module chunks = 0